const status = [
  {
    type: 'delivery',
    statuses: [
      { value: 'new', label: 'Novo pedido', icon: 'far fa-star', color: 'success' },
      { value: 'confirmed', label: 'Pedido Confirmado', icon: 'far fa-check', color: 'light' },
      { value: 'processing', label: 'Em produção', icon: 'far fa-store', color: 'light' },
      { value: 'waiting', label: 'Aguardando entrega', icon: 'fas fa-store', color: 'danger-soft' },
      { value: 'delivering', label: 'Em entrega', icon: 'fas fa-truck', color: 'light' },
      { value: 'delivered', label: 'Entregue', icon: 'far fa-check-circle', color: 'success-soft' },
      { value: 'cancelled', label: 'Cancelado', icon: 'far fa-times-circle', color: 'danger' },
    ]
  },
  {
    type: 'catalog',
    statuses: [
      { value: 'new', label: 'Novo pedido', icon: 'far fa-star', color: 'success' },
      { value: 'confirmed', label: 'Pedido Confirmado', icon: 'far fa-check', color: 'light' },
      { value: 'processing', label: 'Em andamento', icon: 'far fa-store', color: 'light' },
      { value: 'waiting', label: 'Aguardando entrega', icon: 'fas fa-store', color: 'danger-soft' },
      { value: 'delivering', label: 'Em entrega', icon: 'fas fa-truck', color: 'light' },
      { value: 'delivered', label: 'Entregue', icon: 'far fa-check-circle', color: 'success-soft' },
      { value: 'cancelled', label: 'Cancelado', icon: 'far fa-times-circle', color: 'danger' },
    ]
  },
  {
    type: 'market',
    statuses: [
      { value: 'new', label: 'Novo pedido', icon: 'far fa-star', color: 'success' },
      { value: 'confirmed', label: 'Pedido Confirmado', icon: 'far fa-check', color: 'light' },
      { value: 'processing', label: 'Em separação', icon: 'far fa-store', color: 'light' },
      { value: 'waiting', label: 'Aguardando entrega', icon: 'fas fa-store', color: 'danger-soft' },
      { value: 'delivering', label: 'Em entrega', icon: 'fas fa-truck', color: 'light' },
      { value: 'delivered', label: 'Entregue', icon: 'far fa-check-circle', color: 'success-soft' },
      { value: 'cancelled', label: 'Cancelado', icon: 'far fa-times-circle', color: 'danger' },
    ]
  },
  {
    type: 'ecommerce',
    statuses: [
      { value: 'new', label: 'Novo pedido', icon: 'far fa-star', color: 'success' },
      { value: 'confirmed', label: 'Pedido Confirmado', icon: 'far fa-check', color: 'light' },
      { value: 'processing', label: 'Em separação', icon: 'far fa-boxes', color: 'light' },
      { value: 'waiting', label: 'Aguardando entrega', icon: 'fas fa-store', color: 'danger-soft' },
      { value: 'delivering', label: 'Em entrega', icon: 'fas fa-truck', color: 'light' },
      { value: 'delivered', label: 'Entregue', icon: 'far fa-check-circle', color: 'success-soft' },
      { value: 'cancelled', label: 'Cancelado', icon: 'far fa-times-circle', color: 'danger' },
    ]
  },
];

export function getStatus(type, all = true) {
  let statuses = status.find(item => item.type === type).statuses;

  if (!all) {
    statuses = statuses.filter(item => item.value !== 'cancelled');
  }

  return statuses;
}
